import styled from "styled-components";

interface IProps {
  selected: boolean;
  setSelected: () => void;
  rowReverse?: boolean;
}

const IconContainer = styled.div<{selected: boolean, rowReverse: boolean}>`
  cursor: pointer;
  border: 1px solid;
  border-color: ${props => props.selected ? props.theme.colors.primary : props.theme.colors.background};
  border-radius: 9px;
  width: 124px; 
  height: fit-content;
  display: flex;
  flex-direction: ${props => props.rowReverse ? "row-reverse" : "row"};
  align-items: center;
  justify-content: center;
  background-color: ${props => props.theme.colors.placeholder};

  > div {
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 1;
    border-radius: ${props => props.rowReverse ? "8px 0 0 8px" : "0 8px 8px 0"};
  }

  .svg-container {
    background-color: ${props => props.theme.colors.line};
  }
`;

export const AlignIcon = ({selected, setSelected, rowReverse=false}: IProps) => {
  return (
    <IconContainer onClick={setSelected} selected={selected} rowReverse={rowReverse}>
      <div />
      <div className="svg-container">
        <svg width="68" height="61" viewBox="0 0 68 61" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M44 26.3333H16M52 17H16M52 35.6667H16M44 45H16" stroke="#4E4B66" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </div>
    </IconContainer>
  );
}